import React, { useEffect, useState } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import Box from 'components/layouts/Box';
import Text from 'components/commons/Text';
import styled from 'styled-components';
import { useStoreWrapper } from 'stores/StoreHelper';
import BusinessDetailModal from 'components/BusinessList/BusinessDetailModal';
import NewButton from 'components/input/NewButton';
import { Row } from 'saladsoft-primitive';
import ServiceHelper from 'stores/ServiceHelper';
import { AdminBusinessDto } from 'services/data-contracts';
import BusinessForm from 'components/pages/BusinessForm';

const BusinessListPage = () => {
  const { uiStore } = useStoreWrapper();

  const [businesses, setBusinesses] = useState<AdminBusinessDto[]>([]);

  const handleClickNewBusiness = (business?: AdminBusinessDto) => {
    uiStore?.modal.show({
      title: '사업자 등록/수정',
      children: <BusinessForm businessInfo={business} />,
      onConfirmed: () => {
        fetchBusinesses();
      },

      style: {
        width: '900px',
        height: '100%',
        maxHeight: '90vh',
      },
    });
  };

  const fetchBusinesses = () => {
    ServiceHelper.adminBusinessService?.getBusinesses().then((res) => {
      setBusinesses(res.data);
    });
  };

  useEffect(() => {
    fetchBusinesses();
  }, []);

  return (
    <PageLayout
      title="사업자목록"
      actionButton={
        <NewButton
          onClick={() => {
            handleClickNewBusiness();
          }}
        >
          사업자추가
        </NewButton>
      }
    >
      <Row gap={20} flexWrap="wrap" justifyContent="flex-start">
        {/* 사업자 목록 관련 컨텐츠 */}
        {businesses.map((business) => (
          <BusinessBox
            key={business.id}
            onClick={() => {
              handleClickNewBusiness(business);
            }}
          >
            <Text type="H2" style={{ marginBottom: '10px' }}>
              {business.name}
            </Text>
            <Text type="H4">{business.name}</Text>
            <Text type="H5">{business.commerceRegistrationNumber}</Text>
          </BusinessBox>
        ))}
      </Row>
    </PageLayout>
  );
};

const BusinessBox = styled(Box)`
  box-shadow: none;
  border: 1px solid #efefef;
  max-width: 400px;
  padding: 40px;
`;
export default BusinessListPage;
